export default __webpack_public_path__ + "static/media/topicLaunching.63d08942.png";